module.exports = __webpack_public_path__ + "media/images/chevron-up-21ead3be1dbf588b9fb74874b00dd155.svg";